import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import { MarkerWithLabel } from 'react-google-maps/lib/components/addons/MarkerWithLabel';
import { changePort } from 'actions/regions/ports';
import { formValueSelector } from 'redux-form';
import { formName } from 'data/formNames';

class MapComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            zoom: 1,
            center: {
                lat: 41.3533701,
                lng: -11.74670153,
            },
        };

        if (this.props.rememberOldCoords) {
            this.state.oldCoords = this.props.coordinates || [];
        }

        this.mapOnClick = this.mapOnClick.bind(this);
    }

    mapOnClick(event) {
        const latitude = event.latLng.lat();
        const longitude = event.latLng.lng();

        this.props.change && this.props.change('coordinates', [longitude, latitude]);
    }

    UNSAFE_componentWillReceiveProps({ coordinates, rememberOldCoords = false }) {
        const lat = isNaN(parseFloat(coordinates[1])) ? 0 : parseFloat(coordinates[1]);
        const lng = isNaN(parseFloat(coordinates[0])) ? 0 : parseFloat(coordinates[0]);
        const state = {
            center: {
                lat,
                lng,
            },
        };

        if (rememberOldCoords && (!this.state.oldCoords || this.state.oldCoords && !this.state.oldCoords.length)) {
            state.oldCoords = coordinates;
        }

        this.setState(state);
    }

    render() {
        const { coordinates, rememberOldCoords = false } = this.props;
        const { zoom, center, oldCoords = [] } = this.state;

        return (
            <GoogleMap
                ref='googleMap'
                zoom={zoom}
                defaultZoom={1}
                center={center}
                onClick={this.mapOnClick}
                defaultOptions={{
                    scrollwheel: true,
                    draggableCursor: 'pointer',
                }}
            >
                <Marker
                    position={{
                        lat: parseFloat(coordinates[1]),
                        lng: parseFloat(coordinates[0]),
                    }}
                />

                {
                    rememberOldCoords &&
                    <MarkerWithLabel
                        position={{
                            lat: parseFloat(oldCoords[1]),
                            lng: parseFloat(oldCoords[0]),
                        }}
                        labelAnchor={new google.maps.Point(0, 0)}
                        labelStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.3)', color: '#eee', fontSize: '14px' }}
                    >
                        <div>Saved coordinates</div>
                    </MarkerWithLabel>
                }
            </GoogleMap>
        );
    }
}

MapComponent.propTypes = {

};

MapComponent.defaultProps = {

};

const selector = formValueSelector(formName.portCreate);
const MapWithConnect = connect(
    (state, ownProps) => ({
        ...ownProps,
        coordinates: selector(state, 'coordinates') || ownProps.coordinates,
    }),
    dispatch => bindActionCreators({
        changePort,
    }, dispatch),
)(MapComponent);

const MyMapComponent = withGoogleMap(MapWithConnect);

export default MyMapComponent;



// WEBPACK FOOTER //
// ./app/components/Regions/PortAdd/MapComponent.jsx